import { render, staticRenderFns } from "./VoteResult.vue?vue&type=template&id=eda2f850"
import script from "./VoteResult.vue?vue&type=script&lang=js"
export * from "./VoteResult.vue?vue&type=script&lang=js"
import style0 from "./VoteResult.vue?vue&type=style&index=0&id=eda2f850&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports